module.exports = __webpack_public_path__ + "img/cww_08.75fe5ab2.jpg";